import React from "react";
import { useTranslation } from "react-i18next";
import IconContainer from "@/components/ui/icon-container";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "@/components/ui/tooltip";
import { InfoCircle } from "@dreamhub/designsystem/icons";

export const BlankIcon: React.FC = () => (
  <IconContainer size="sm" as="span" className="text-text-warning shrink-0">
    <InfoCircle />
  </IconContainer>
);

interface Props {
  // Empty on the record, so nothing typed here can fill it.
  missing?: boolean;
}

export const BlankMarker: React.FC<Props> = ({ missing = false }) => {
  const { t } = useTranslation();
  const label = t(
    missing
      ? "contracts.proposals.editor.missingCrmData"
      : "contracts.proposals.editor.needsInput"
  );
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span role="img" aria-label={label} className="flex">
          <BlankIcon />
        </span>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
};
